/* Riivah landing page behaviour.
   Extracted from the delivered index.html, one IIFE per section, page order.
   The contact and newsletter forms are Shopify {% form %} tags in the theme,
   so their client-side-only handlers were dropped: they post for real. */

/* SHARED: JS-gated per-element reveal for every section that has reveal items */
(function () {
  var sections = document.querySelectorAll(
    '.riivah-lp-intro, .riivah-lp-expressions, .riivah-lp-product, .riivah-lp-discovery,' +
    '.riivah-lp-perfumer, .riivah-lp-voices, .riivah-lp-study, .riivah-lp-faq,' +
    '.riivah-lp-contact, .riivah-lp-define'
  );
  if (!sections.length) { return; }

  Array.prototype.forEach.call(sections, function (section) {
    if (!section.querySelector('.riivah-lp-reveal')) { return; }
    section.classList.add('riivah-lp-reveal-ready');
  });

  var items = document.querySelectorAll('.riivah-lp-reveal-ready .riivah-lp-reveal');
  if (!items.length) { return; }

  if (!('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(items, function (el) { el.classList.add('is-revealed'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) { return; }
      var element = entry.target;
      if (window.RiivahParagraphReveal) {
        window.RiivahParagraphReveal.before(element, function (afterParagraphs) {
          if (afterParagraphs) { element.style.setProperty('--riivah-lp-reveal-delay', '0ms'); }
          element.classList.add('is-revealed');
        });
      } else {
        element.classList.add('is-revealed');
      }
      observer.unobserve(element);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  Array.prototype.forEach.call(items, function (el) { observer.observe(el); });
})();

/* SECTION 1: HERO - section-level reveal sequence */
(function () {
  var hero = document.querySelector('.riivah-lp-hero');
  if (!hero) { return; }
  hero.classList.add('riivah-lp-reveal-ready');

  var video = hero.querySelector('.riivah-lp-hero-video');
  if (video) {
    video.play().catch(function () {});
  }

  if (!('IntersectionObserver' in window)) { hero.classList.add('is-hero-visible'); return; }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) { return; }
      hero.classList.add('is-hero-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  observer.observe(hero);
})();

/* SECTION 8: VOICES - centred, continuously looping testimonial carousel */
(function () {
  function init(section) {
    if (section._riivahVoicesCleanup) { return; }
    var viewport = section.querySelector('.riivah-lp-voices-viewport');
    var track = section.querySelector('[data-riivah-track]');
    var prev = section.querySelector('[data-riivah-prev]');
    var next = section.querySelector('[data-riivah-next]');
    var cards = track ? Array.prototype.slice.call(track.querySelectorAll('.riivah-lp-voices-card')) : [];
    if (!viewport || !track || !cards.length) { return; }
    var index = Math.floor(cards.length / 2);
    var buffer = 0, width = 0, step = 0, viewportWidth = 0;
    var queue = [], moving = false, destroyed = false, timer = 0;
    var originalTransform = track.style.transform;
    var originalTransition = track.style.transition;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    var observer;

    // Optional four-line preview. Full copy remains visible without JavaScript.
    var preview = section.hasAttribute('data-testimonial-read-more');
    function measureQuotes() {
      if (!preview || destroyed) { return; }
      Array.prototype.forEach.call(track.querySelectorAll('.riivah-lp-voices-card'), function (card) {
        var quote = card.querySelector('.riivah-lp-voices-text');
        var button = card.querySelector('[data-quote-toggle]');
        if (!quote || !button) { return; }
        var limit = parseFloat(window.getComputedStyle(quote).lineHeight) * 4;
        var full = quote.querySelector('[data-quote-content]').scrollHeight;
        if (!limit || !full) { return; }
        quote.style.setProperty('--quote-line-height', (limit / 4) + 'px');
        button.hidden = full <= limit + 1 || button.getAttribute('aria-expanded') === 'true';
        quote.style.height = (button.getAttribute('aria-expanded') === 'true' ? full : Math.min(full, limit)) + 'px';
      });
    }
    function closeQuoteOutside(event) {
      var expanded = track.querySelector('[data-quote-toggle][aria-expanded="true"]');
      if (!expanded || expanded.closest('.riivah-lp-voices-card').contains(event.target)) { return; }
      expanded.setAttribute('aria-expanded', 'false');
      measureQuotes();
    }
    function toggleQuote(event) {
      var button = event.target.closest('[data-quote-toggle]');
      if (!button || !track.contains(button)) { return; }
      Array.prototype.forEach.call(track.querySelectorAll('[data-quote-toggle]'), function (match) {
        match.setAttribute('aria-expanded', String(match === button));
      });
      measureQuotes();
    }
    if (preview) {
      cards.forEach(function (card, i) {
        var quote = card.querySelector('.riivah-lp-voices-text');
        if (!quote) { return; }
        var content = document.createElement('span');
        content.setAttribute('data-quote-content', '');
        content.style.display = 'block';
        while (quote.firstChild) { content.appendChild(quote.firstChild); }
        quote.appendChild(content);
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'riivah-lp-voices-more';
        button.setAttribute('data-quote-toggle', String(i));
        button.setAttribute('aria-expanded', 'false');
        button.textContent = 'Read more';
        button.hidden = true;
        quote.appendChild(button);
        quote.style.height = quote.getBoundingClientRect().height + 'px';
      });
      section.classList.add('has-quote-previews');
      measureQuotes();
      track.addEventListener('click', toggleQuote);
      document.addEventListener('click', closeQuoteOutside);
      window.addEventListener('resize', measureQuotes);
      if (document.fonts && document.fonts.ready) { document.fonts.ready.then(measureQuotes); }
    }

    function removeClones() {
      Array.prototype.forEach.call(track.querySelectorAll('[data-riivah-clone]'), function (clone) { clone.remove(); });
    }
    function cloneCard(position) {
      var clone = cards[(position % cards.length + cards.length) % cards.length].cloneNode(true);
      [clone].concat(Array.prototype.slice.call(clone.querySelectorAll('*'))).forEach(function (node) {
        Array.prototype.slice.call(node.attributes).forEach(function (attr) {
          if (attr.name === 'id' || attr.name.indexOf('data-shopify') === 0) { node.removeAttribute(attr.name); }
        });
      });
      var toggle = clone.querySelector('[data-quote-toggle]');
      if (toggle) { toggle.setAttribute('aria-expanded', 'false'); }
      clone.setAttribute('data-riivah-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      // Visible loop copies must accept pointer clicks. Keep their controls
      // out of keyboard navigation; originals provide the accessible controls.
      if (toggle) { toggle.setAttribute('tabindex', '-1'); }
      else { clone.setAttribute('inert', ''); }
      return clone;
    }
    function position(animate) {
      track.style.transition = animate ? originalTransition : 'none';
      track.style.transform = 'translateX(' + (viewportWidth / 2 - ((buffer + index) * step + width / 2)) + 'px)';
      if (!animate) { void track.offsetWidth; }
    }
    function finish() {
      if (!moving || destroyed) { return; }
      window.clearTimeout(timer);
      moving = false;
      index = (index % cards.length + cards.length) % cards.length;
      position(false);
      drain();
    }
    function drain() {
      if (moving || destroyed || !step || !queue.length) { return; }
      index += queue.shift();
      moving = true;
      position(!(reduced && reduced.matches));
      if (reduced && reduced.matches) { finish(); return; }
      // A fallback also completes navigation when transitionend is suppressed.
      timer = window.setTimeout(finish, 600);
    }
    function layout() {
      if (destroyed) { return; }
      var measured = cards[0].getBoundingClientRect().width;
      var vw = viewport.clientWidth;
      if (!measured || !vw) { return; }
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap) || parseFloat(styles.gap) || 0;
      if (width === measured && viewportWidth === vw && step === measured + gap) { return; }
      window.clearTimeout(timer);
      moving = false;
      index = (index % cards.length + cards.length) % cards.length;
      width = measured;
      viewportWidth = vw;
      step = width + gap;
      // Cover either half of the viewport plus the next animated step, even
      // when the merchant has supplied only one or two original cards.
      buffer = Math.ceil(vw / step) + 2;
      removeClones();
      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      for (var i = -buffer; i < 0; i++) { before.appendChild(cloneCard(i)); }
      for (var j = cards.length; j < cards.length + buffer; j++) { after.appendChild(cloneCard(j)); }
      track.insertBefore(before, cards[0]);
      track.appendChild(after);
      measureQuotes();
      position(false);
      drain();
    }
    function go(delta) { queue.push(delta); layout(); drain(); }
    function backwards() { go(-1); }
    function forwards() { go(1); }
    function ended(event) { if (event.target === track && event.propertyName === 'transform') { finish(); } }
    if (prev) { prev.addEventListener('click', backwards); }
    if (next) { next.addEventListener('click', forwards); }
    track.addEventListener('transitionend', ended);
    window.addEventListener('load', layout);
    window.addEventListener('resize', layout);
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(layout);
      observer.observe(viewport);
      observer.observe(cards[0]);
    }
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(layout); }
    section._riivahVoicesCleanup = function () {
      destroyed = true;
      window.clearTimeout(timer);
      if (observer) { observer.disconnect(); }
      if (prev) { prev.removeEventListener('click', backwards); }
      if (next) { next.removeEventListener('click', forwards); }
      track.removeEventListener('transitionend', ended);
      window.removeEventListener('load', layout);
      window.removeEventListener('resize', layout);
      track.removeEventListener('click', toggleQuote);
      document.removeEventListener('click', closeQuoteOutside);
      window.removeEventListener('resize', measureQuotes);
      section.classList.remove('has-quote-previews');
      cards.forEach(function (card) {
        var quote = card.querySelector('.riivah-lp-voices-text');
        var button = card.querySelector('[data-quote-toggle]');
        if (quote && preview) {
          quote.style.removeProperty('height');
          quote.style.removeProperty('--quote-line-height');
          var content = quote.querySelector('[data-quote-content]');
          if (content) { while (content.firstChild) { quote.insertBefore(content.firstChild, content); } content.remove(); }
        }
        if (button) { button.remove(); }
      });
      removeClones();
      track.style.transform = originalTransform;
      track.style.transition = originalTransition;
      delete section._riivahVoicesCleanup;
    };
    layout();
  }
  function sections(root, callback) {
    if (root.matches && root.matches('.riivah-lp-voices')) { callback(root); }
    Array.prototype.forEach.call(root.querySelectorAll('.riivah-lp-voices'), callback);
  }
  sections(document, init);
  document.addEventListener('shopify:section:load', function (event) { sections(event.target, init); });
  document.addEventListener('shopify:section:unload', function (event) {
    sections(event.target, function (section) { if (section._riivahVoicesCleanup) { section._riivahVoicesCleanup(); } });
  });
})();

/* SECTION 10: FAQ - category tabs + single-open accordion */
(function () {
  var section = document.querySelector('.riivah-lp-faq');
  if (!section) { return; }

  var tabs = section.querySelectorAll('[data-riivah-tab]');
  var panels = section.querySelectorAll('.riivah-lp-faq-panel');

  Array.prototype.forEach.call(panels, function (panel) {
    Array.prototype.forEach.call(panel.querySelectorAll('.riivah-lp-faq-item'), function (item, index) {
      item.style.setProperty('--riivah-faq-item-delay', Math.min(index * 60, 300) + 'ms');
    });
  });

  Array.prototype.forEach.call(tabs, function (tab) {
    tab.addEventListener('click', function () {
      if (tab.classList.contains('is-active')) { return; }
      var id = tab.getAttribute('data-riivah-tab');
      Array.prototype.forEach.call(tabs, function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      Array.prototype.forEach.call(panels, function (p) {
        var active = p.id === id;
        p.classList.toggle('is-active', active);
        p.classList.toggle('is-tab-revealing', active);
      });
    });
  });

  Array.prototype.forEach.call(section.querySelectorAll('.riivah-lp-faq-q'), function (button) {
    button.addEventListener('click', function () {
      var item = button.parentNode;
      var panel = item.parentNode;
      var open = item.classList.contains('is-open');

      Array.prototype.forEach.call(panel.querySelectorAll('.riivah-lp-faq-item'), function (other) {
        other.classList.remove('is-open');
        var q = other.querySelector('.riivah-lp-faq-q');
        var icon = other.querySelector('.riivah-lp-faq-q-icon');
        if (q) { q.setAttribute('aria-expanded', 'false'); }
        if (icon) { icon.textContent = '+'; }
      });

      if (!open) {
        item.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
        var icon = button.querySelector('.riivah-lp-faq-q-icon');
        if (icon) { icon.textContent = '−'; }
      }
    });
  });
})();

/* HEADER: navigation overlay, added for the theme.
   The nav hides behind a burger below 1024px (the design said 1280; T02-5
   kept the full nav down to 1024) but the design ships no panel;
   this opens the overlay added in riivah-lp.css. Because that overlay is opaque
   and covers the burger, it is a real modal: focus moves in on open, is trapped
   while open, and returns to the burger on close. */
(function () {
  var BREAK = 1023;  /* must match the CSS breakpoint that hides the overlay */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]),' +
                  ' select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var OUT = 280;     /* must match the closing keyframe duration in the CSS */

  var header = null;
  var burger = null;
  var menu = null;
  var closer = null;
  var opener = null;   /* what had focus before we opened */
  var open = false;
  var closing = 0;

  function siblings() {
    /* everything the overlay is NOT, so it can be made inert while open */
    var out = [];
    var kids = document.body.children;
    var i;
    for (i = 0; i < kids.length; i++) {
      if (kids[i] !== menu && !kids[i].contains(menu)) { out.push(kids[i]); }
    }
    return out;
  }

  function background(hide) {
    var list = siblings();
    var i;
    for (i = 0; i < list.length; i++) {
      if (hide) {
        list[i].setAttribute('aria-hidden', 'true');
        if ('inert' in list[i]) { list[i].inert = true; }
      } else {
        list[i].removeAttribute('aria-hidden');
        if ('inert' in list[i]) { list[i].inert = false; }
      }
    }
  }

  function items() {
    if (!menu) { return []; }
    var all = menu.querySelectorAll(FOCUSABLE);
    var out = [];
    var i;
    for (i = 0; i < all.length; i++) {
      /* skip anything the current breakpoint has hidden */
      if (all[i].offsetWidth || all[i].offsetHeight || all[i].getClientRects().length) { out.push(all[i]); }
    }
    return out;
  }

  function trap(event) {
    if (!open || event.key !== 'Tab') { return; }
    var list = items();
    if (!list.length) { return; }
    var first = list[0];
    var last = list[list.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function setOpen(next) {
    if (!menu || !burger || next === open) { return; }
    open = next;

    if (open) { opener = document.activeElement; }

    /* the panel has to stay laid out while it slides away, so closing swaps
       .is-open for .is-closing and drops that one beat later */
    if (closing) { window.clearTimeout(closing); closing = 0; }
    menu.classList.remove('is-closing');
    if (!open) {
      menu.classList.add('is-closing');
      closing = window.setTimeout(function () {
        closing = 0;
        if (menu) { menu.classList.remove('is-closing'); }
      }, OUT);
    }

    menu.classList.toggle('is-open', open);
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    document.body.classList.toggle('riivah-lp-menu-open', open);
    background(open);
    /* one modal at a time: the cart listens for this and closes itself */
    if (open) {
      var ev;
      try { ev = new CustomEvent('riivah:menu-open', { bubbles: true }); }
      catch (e) { ev = document.createEvent('CustomEvent'); ev.initCustomEvent('riivah:menu-open', true, false, {}); }
      document.dispatchEvent(ev);
    }

    if (open) {
      /* the burger is underneath an opaque overlay now, so focus has to move */
      if (closer) {
        closer.focus();
      } else {
        var list = items();
        if (list.length) { list[0].focus(); }
      }
    } else if (opener && opener.focus) {
      opener.focus();
      opener = null;
    } else if (burger) {
      burger.focus();
    }
  }

  function onBurger() { setOpen(!open); }
  function onClose() { setOpen(false); }

  function onMenuClick(event) {
    /* a link navigates, so the overlay should not still be up behind it */
    if (event.target.closest && event.target.closest('a')) { setOpen(false); }
  }

  function onDocClick(event) {
    /* the tablet form leaves a strip of page visible; clicking it dismisses.
       On phones the overlay is full-bleed, so this can never fire. */
    if (!open || !menu) { return; }
    if (menu.contains(event.target)) { return; }
    if (burger && burger.contains(event.target)) { return; }
    setOpen(false);
  }

  function onKey(event) {
    if (event.key === 'Escape') { setOpen(false); }
    trap(event);
  }

  function onResize() {
    if (window.innerWidth > BREAK) { setOpen(false); }
  }

  function detach() {
    if (burger) { burger.removeEventListener('click', onBurger); }
    if (closer) { closer.removeEventListener('click', onClose); }
    if (menu) { menu.removeEventListener('click', onMenuClick); }
  }

  function attach() {
    detach();
    header = document.querySelector('.riivah-lp-header');
    if (!header) { menu = null; burger = null; closer = null; return; }

    burger = header.querySelector('.riivah-lp-header-burger');
    /* the overlay is NOT inside the header - it cannot be, or the header's
       backdrop-filter and transform would trap it - so look it up by id */
    menu = document.getElementById('riivah-header-menu');
    closer = menu ? menu.querySelector('.riivah-lp-header-menu-close') : null;
    if (!burger || !menu) { return; }

    burger.setAttribute('aria-expanded', 'false');
    burger.setAttribute('aria-controls', menu.id);

    burger.addEventListener('click', onBurger);
    if (closer) { closer.addEventListener('click', onClose); }
    menu.addEventListener('click', onMenuClick);

    /* a section reload replaces the element, so re-sync to our state */
    open = false;
    if (closing) { window.clearTimeout(closing); closing = 0; }
    menu.classList.remove('is-open');
    menu.classList.remove('is-closing');
    document.body.classList.remove('riivah-lp-menu-open');
    background(false);
  }

  attach();
  document.addEventListener('click', onDocClick);
  document.addEventListener('keydown', onKey);
  document.addEventListener('riivah:cart-open', function () { if (open) { setOpen(false); } });
  window.addEventListener('resize', onResize, { passive: true });

  /* the theme editor swaps the header section out; re-resolve the elements */
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('.riivah-lp-header')) { attach(); }
  });
  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target && event.target.querySelector('.riivah-lp-header')) {
      setOpen(false);
      detach();
      header = null; burger = null; menu = null; closer = null;
    }
  });
})();

/* HEADER: scrolled state.
   The design supplies a scrolled nav but the delivered page had no scroll
   handling at all. The panel is meant to appear as the page leaves the hero and
   the second section arrives, so the threshold is the hero's own bottom edge
   rather than a fixed number - the hero is responsive and its height is not
   knowable up front. Release is a little lower than engage so resting on the
   line cannot flicker; the transition itself is suppressed in CSS under
   prefers-reduced-motion. */
(function () {
  var FALLBACK = 24;  /* the hero is missing, as on inner templates */
  var PHONE = 600;    /* must match the CSS breakpoint that makes the panel full width */
  var EARLY = 24;     /* phones show the panel inside the hero, not after it */
  var LEAD = 0.18;    /* wider screens engage this much of the hero before its end */
  var SLACK = 12;     /* release below engage, so resting on the line cannot flicker */
  var LIFT = 240;     /* must match the lift keyframe duration in the CSS */

  var header = null;
  var hero = null;
  var threshold = FALLBACK;
  var scrolled = false;
  var ticking = false;
  var lifting = 0;

  function measure() {
    /* phones want the panel almost immediately; only wider screens wait for the
       hero to pass, and the width test has to match the CSS breakpoint */
    if (window.innerWidth <= PHONE) { threshold = EARLY; return; }
    if (!hero) { threshold = FALLBACK; return; }
    /* engage a little before the hero's last pixel clears the top, so the panel
       has arrived by the time the second section does. The lead is a fraction of
       the hero rather than a fixed number, so it reads the same on a short phone
       landscape as on a tall desktop. */
    var top = 0;
    var node = hero;
    while (node) { top += node.offsetTop; node = node.offsetParent; }
    var height = hero.offsetHeight;
    threshold = Math.max(top + height - (height * LEAD), FALLBACK);
  }

  function apply() {
    ticking = false;
    if (!header) { return; }
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (scrolled ? y <= threshold - SLACK : y >= threshold) {
      scrolled = !scrolled;
      header.classList.toggle('is-scrolled', scrolled);
      if (scrolled) {
        /* coming back down mid-lift: cancel it rather than let it finish */
        endLift();
      } else if (window.innerWidth <= PHONE) {
        /* phones have no lift animation to wait for, so drop the chrome at once */
        endLift();
      } else {
        /* the panel keeps its pinned chrome for one animation, then drops it */
        header.classList.add('is-lifting');
        if (lifting) { window.clearTimeout(lifting); }
        lifting = window.setTimeout(endLift, LIFT);
      }
    }
  }

  function endLift() {
    if (lifting) { window.clearTimeout(lifting); lifting = 0; }
    if (header) { header.classList.remove('is-lifting'); }
  }

  function onScroll() {
    if (ticking) { return; }
    ticking = true;
    window.requestAnimationFrame(apply);
  }

  function onResize() {
    measure();
    onScroll();
  }

  function attach() {
    header = document.querySelector('.riivah-lp-header');
    hero = document.querySelector('.riivah-lp-hero');
    if (!header) { return; }
    measure();
    /* a section reload replaces the element, so re-sync the class to our state */
    endLift();
    header.classList.toggle('is-scrolled', scrolled);
    apply();
  }

  if (!('requestAnimationFrame' in window)) { return; }

  attach();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize, { passive: true });
  /* the hero carries a video and a web font, so its height can settle after
     first paint - re-measure once everything has loaded */
  window.addEventListener('load', onResize);

  /* the theme editor swaps the header section out; re-resolve the element */
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('.riivah-lp-header')) { attach(); }
    else if (event.target && event.target.querySelector('.riivah-lp-hero')) { onResize(); }
  });
  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target && event.target.querySelector('.riivah-lp-header')) { header = null; }
  });
})();

/* CONTACT: custom inquiry dropdown, conditional message label, damage photos.
   The native <select> stays in the DOM and keeps name="contact[Inquiry type]",
   so the form posts correctly and still works with JS disabled; this hides it
   and drives it from a custom combobox.

   The picked files are held in the browser only. Shopify's contact form renders
   without enctype="multipart/form-data" and cannot carry file bytes, so sending
   them anywhere needs a storage step that has not been built yet. Until it is,
   only the filenames post, in contact[Damage photos]. */
(function () {
  var UPLOAD_OPTION = 'Damaged Product & Exchange';
  var MAX_BYTES = 10 * 1024 * 1024;   /* matches the "up to 10MB" the form promises */
  var LABELS = {
    'Returns': 'Reason for Return (Required)',
    'Damaged Product & Exchange': 'Damage Description (Required)'
  };
  var DEFAULT_LABEL = 'Message';

  function init(root) {
    var field = root.querySelector('.riivah-lp-contact-field-inquiry');
    var select = field && field.querySelector('[data-riivah-inquiry]');
    if (!field || !select) { return null; }

    var messageLabel = root.querySelector('[data-riivah-message-label]');
    var upload = root.querySelector('[data-riivah-upload]');
    var drop = root.querySelector('[data-riivah-drop]');
    var input = root.querySelector('[data-riivah-files]');
    var browse = root.querySelector('[data-riivah-browse]');
    var list = root.querySelector('[data-riivah-thumbs]');
    var status = root.querySelector('[data-riivah-upload-status]');
    var names = root.querySelector('[data-riivah-filenames]');
    var note = root.querySelector('[data-riivah-upload-note]');
    var more = root.querySelector('[data-riivah-more]');

    var files = [];
    var urls = [];
    var open = false;
    var active = -1;

    var options = [];
    Array.prototype.forEach.call(select.options, function (opt) {
      if (opt.value) { options.push({ value: opt.value, label: opt.textContent }); }
    });
    if (!options.length) { return null; }

    var placeholder = select.options.length ? select.options[0].textContent : 'Select';
    var listId = 'riivah-inquiry-list';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'riivah-lp-contact-select';
    trigger.setAttribute('role', 'combobox');
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', listId);
    trigger.setAttribute('aria-labelledby', 'riivah-inquiry-label');

    var value = document.createElement('span');
    value.className = 'riivah-lp-contact-select-value';
    var caret = document.createElement('span');
    caret.className = 'riivah-lp-contact-select-caret';
    caret.setAttribute('aria-hidden', 'true');
    trigger.appendChild(value);
    trigger.appendChild(caret);

    var listbox = document.createElement('ul');
    listbox.className = 'riivah-lp-contact-options';
    listbox.id = listId;
    listbox.setAttribute('role', 'listbox');
    listbox.hidden = true;

    options.forEach(function (opt, i) {
      var li = document.createElement('li');
      li.className = 'riivah-lp-contact-option';
      li.id = listId + '-' + i;
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');
      li.textContent = opt.label;
      li.addEventListener('click', function () { commit(i); });
      listbox.appendChild(li);
    });

    field.appendChild(trigger);
    field.appendChild(listbox);
    field.classList.add('is-enhanced');
    /* keep the native control posting, but out of the tab order and a11y tree */
    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');

    var rows = listbox.querySelectorAll('.riivah-lp-contact-option');

    function indexOfValue(v) {
      for (var i = 0; i < options.length; i++) { if (options[i].value === v) { return i; } }
      return -1;
    }

    function paint() {
      var i = indexOfValue(select.value);
      value.textContent = i < 0 ? placeholder : options[i].label;
      trigger.classList.toggle('is-empty', i < 0);
      Array.prototype.forEach.call(rows, function (row, n) {
        row.setAttribute('aria-selected', n === i ? 'true' : 'false');
      });
      if (messageLabel) {
        messageLabel.textContent = LABELS[select.value] || DEFAULT_LABEL;
      }
      if (upload) {
        var wanted = select.value === UPLOAD_OPTION;
        upload.hidden = !wanted;
        if (!wanted) { clearFiles(); }
      }
    }

    function setActive(i) {
      active = i;
      Array.prototype.forEach.call(rows, function (row, n) {
        row.classList.toggle('is-active', n === i);
      });
      if (i < 0) { trigger.removeAttribute('aria-activedescendant'); }
      else { trigger.setAttribute('aria-activedescendant', rows[i].id); }
    }

    function openList() {
      if (open) { return; }
      open = true;
      listbox.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      var i = indexOfValue(select.value);
      setActive(i < 0 ? 0 : i);
    }

    function closeList(focus) {
      if (!open) { return; }
      open = false;
      listbox.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      setActive(-1);
      if (focus) { trigger.focus(); }
    }

    function commit(i) {
      if (i < 0 || i >= options.length) { return; }
      select.value = options[i].value;
      /* let anything else bound to the native control react */
      if (typeof Event === 'function') {
        select.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        paint();
      }
      closeList(true);
    }

    trigger.addEventListener('click', function () {
      if (open) { closeList(false); } else { openList(); }
    });

    trigger.addEventListener('keydown', function (event) {
      var key = event.key;
      if (key === 'Escape') { if (open) { event.preventDefault(); closeList(true); } return; }
      if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
        event.preventDefault();
        if (open) { commit(active); } else { openList(); }
        return;
      }
      if (key === 'ArrowDown') {
        event.preventDefault();
        if (!open) { openList(); }
        else if (active < options.length - 1) { setActive(active + 1); }
        return;
      }
      if (key === 'ArrowUp') {
        event.preventDefault();
        if (!open) { openList(); setActive(options.length - 1); }
        else if (active > 0) { setActive(active - 1); }
        return;
      }
      if (key === 'Home') { if (open) { event.preventDefault(); setActive(0); } return; }
      if (key === 'End') { if (open) { event.preventDefault(); setActive(options.length - 1); } return; }
      if (key === 'Tab') { closeList(false); return; }
      if (key && key.length === 1 && /\S/.test(key)) {
        var ch = key.toLowerCase();
        for (var n = 1; n <= options.length; n++) {
          var idx = ((active < 0 ? 0 : active) + n) % options.length;
          if (options[idx].label.toLowerCase().charAt(0) === ch) {
            if (!open) { openList(); }
            setActive(idx);
            break;
          }
        }
      }
    });

    function onDocDown(event) {
      if (!open) { return; }
      if (field.contains(event.target)) { return; }
      closeList(false);
    }
    document.addEventListener('mousedown', onDocDown, { passive: true });

    /* ---- damage photos ---- */
    /* The customer's photos go to Cloudinary and their links travel with the
       form. Shopify's contact form cannot carry files, so this is the transport.
       Both credentials are public by design and come from theme settings, so
       the preset can be rotated without a deploy. */
    var CLOUD = upload ? upload.getAttribute('data-cloud') : '';
    var PRESET = upload ? upload.getAttribute('data-preset') : '';
    var MAX_FILES = 5;
    var MAX_EDGE = 1800;      /* a damage photo needs detail, not a billboard */
    var QUALITY = 0.82;
    var TIMEOUT = 20000;

    function say(text) { if (status) { status.textContent = text; } }

    /* Shrink before sending. An 8MB phone photo lands well under 1MB, so the
       upload is quick and the customer is not waiting on their own connection.
       Falls back to the original file if anything about this fails - a slightly
       slow upload beats no upload. */
    function compress(file) {
      return new Promise(function (resolve) {
        if (!window.URL || !window.HTMLCanvasElement) { return resolve(file); }

        /* Neither onload nor onerror is guaranteed to fire - a corrupt file, or
           an environment that does not decode images, leaves both silent and the
           promise pending forever, which would strand the upload. Settle once,
           whichever happens first, including a timeout. */
        var settled = false;
        var img = new Image();
        var url = URL.createObjectURL(file);

        function finish(result) {
          if (settled) { return; }
          settled = true;
          window.clearTimeout(guard);
          URL.revokeObjectURL(url);
          resolve(result);
        }

        var guard = window.setTimeout(function () { finish(file); }, 4000);

        img.onload = function () {
          try {
            var w = img.naturalWidth;
            var h = img.naturalHeight;
            if (!w || !h) { return finish(file); }
            var scale = Math.min(1, MAX_EDGE / Math.max(w, h));
            var canvas = document.createElement('canvas');
            canvas.width = Math.round(w * scale);
            canvas.height = Math.round(h * scale);
            canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
            canvas.toBlob(function (blob) {
              /* keep whichever is smaller: re-encoding a small PNG can grow it */
              finish(blob && blob.size < file.size ? blob : file);
            }, 'image/jpeg', QUALITY);
          } catch (e) { finish(file); }
        };
        img.onerror = function () { finish(file); };
        img.src = url;
      });
    }

    /* One file to Cloudinary. Resolves with a URL, or null - never rejects, so
       one bad photo cannot take the others down with it. */
    function send(file) {
      if (!CLOUD || !PRESET) { return Promise.resolve(null); }
      return compress(file).then(function (blob) {
        var body = new FormData();
        body.append('file', blob, file.name);
        body.append('upload_preset', PRESET);

        var ctrl = window.AbortController ? new AbortController() : null;
        var timer = window.setTimeout(function () { if (ctrl) { ctrl.abort(); } }, TIMEOUT);

        return fetch('https://api.cloudinary.com/v1_1/' + CLOUD + '/image/upload', {
          method: 'POST',
          body: body,
          signal: ctrl ? ctrl.signal : undefined
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            window.clearTimeout(timer);
            return data && data.secure_url ? data.secure_url : null;
          })
          .catch(function () { window.clearTimeout(timer); return null; });
      });
    }

    /* Write whatever has landed into the hidden field the form posts. Files
       still uploading, or that failed, simply are not listed. */
    function syncNames() {
      if (names) {
        var done = files.filter(function (f) { return f.url; });
        names.value = done.map(function (f) { return f.url; }).join('\n');
      }
      if (!note) { return; }

      /* The form never waits for an upload, so anything unfinished or failed
         has to be visible - otherwise a photo is lost silently. */
      var pending = files.filter(function (f) { return !f.url && !f.failed; }).length;
      var failed = files.filter(function (f) { return f.failed; }).length;

      if (failed) {
        note.textContent = failed === 1
          ? 'One photo could not be uploaded. Remove and try it again, or send the message without it.'
          : failed + ' photos could not be uploaded. Remove and try them again, or send the message without them.';
        note.hidden = false;
      } else if (pending) {
        note.textContent = pending === 1
          ? 'One photo is still uploading.'
          : pending + ' photos are still uploading.';
        note.hidden = false;
      } else {
        note.textContent = '';
        note.hidden = true;
      }
    }

    function revoke() {
      urls.forEach(function (u) { URL.revokeObjectURL(u); });
      urls = [];
    }

    function clearFiles() {
      if (!files.length) { return; }
      files = [];
      revoke();
      if (input) { input.value = ''; }
      render();
    }

    function render() {
      if (!list || !drop) { return; }
      revoke();
      while (list.firstChild) { list.removeChild(list.firstChild); }

      files.forEach(function (rec) {
        /* the preview comes from the local file, so it appears immediately and
           does not wait on the upload */
        var url = URL.createObjectURL(rec.file);
        urls.push(url);

        var li = document.createElement('li');
        li.className = 'riivah-lp-contact-thumb';
        if (!rec.url) { li.classList.add(rec.failed ? 'is-failed' : 'is-uploading'); }

        var img = document.createElement('img');
        img.src = url;
        img.alt = 'Selected photo for damage report: ' + rec.file.name;
        li.appendChild(img);

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'riivah-lp-contact-thumb-remove';
        /* the accessible name has to say WHICH file it removes */
        btn.setAttribute('aria-label', 'Remove ' + rec.file.name);
        var icon = document.createElement('span');
        icon.setAttribute('aria-hidden', 'true');
        btn.appendChild(icon);
        btn.addEventListener('click', function () { remove(rec); });
        li.appendChild(btn);

        list.appendChild(li);
      });

      var any = files.length > 0;
      list.hidden = !any;
      /* the empty state is gone once files exist; the list carries the same border */
      drop.hidden = any;
      /* with the empty dropzone gone, this is the only way to add another */
      if (more) { more.hidden = !any || files.length >= MAX_FILES; }
      syncNames();
    }

    function remove(rec) {
      var i = files.indexOf(rec);
      if (i < 0) { return; }
      files.splice(i, 1);
      if (input) { input.value = ''; }
      render();
      say('Removed ' + rec.file.name + '. ' + files.length + ' selected.');
      /* never strand focus on a node we just removed */
      var next = list && list.querySelector('.riivah-lp-contact-thumb-remove');
      if (next) { next.focus(); } else if (browse) { browse.focus(); }
    }

    function accept(incoming) {
      var added = 0;
      var rejected = 0;
      var full = 0;
      var fresh = [];
      Array.prototype.forEach.call(incoming, function (file) {
        if (!/^image\/(jpeg|png)$/.test(file.type) || file.size > MAX_BYTES) { rejected++; return; }
        /* a cap keeps the posted field a sensible length and bounds misuse */
        if (files.length >= MAX_FILES) { full++; return; }
        var rec = { file: file, url: null, failed: false };
        files.push(rec);
        fresh.push(rec);
        added++;
      });
      render();

      var msg = added + ' file' + (added === 1 ? '' : 's') + ' added, ' + files.length + ' selected.';
      if (rejected) { msg += ' ' + rejected + ' rejected: JPEG or PNG, up to 10MB.'; }
      if (full) { msg += ' ' + full + ' not added: ' + MAX_FILES + ' photos maximum.'; }
      say(msg);

      /* Upload as soon as the file is chosen, not at submit, so by the time the
         customer has finished typing these are usually already done. */
      fresh.forEach(function (rec) {
        send(rec.file).then(function (url) {
          if (files.indexOf(rec) < 0) { return; }   /* removed while in flight */
          rec.url = url;
          rec.failed = !url;
          render();
        });
      });
    }

    if (browse && input) {
      browse.addEventListener('click', function () { input.click(); });
      /* same picker, reached from under the thumbnails */
      if (more) { more.addEventListener('click', function () { input.click(); }); }
      input.addEventListener('change', function () {
        accept(input.files);
        /* clear it, or choosing the SAME file again fires no change event */
        input.value = '';
      });
    }

    if (drop) {
      drop.addEventListener('dragover', function (event) {
        event.preventDefault();
        drop.classList.add('is-dragover');
      });
      drop.addEventListener('dragleave', function () {
        drop.classList.remove('is-dragover');
      }, { passive: true });
      drop.addEventListener('drop', function (event) {
        event.preventDefault();
        drop.classList.remove('is-dragover');
        if (event.dataTransfer && event.dataTransfer.files) { accept(event.dataTransfer.files); }
      });
    }

    /* restores the choice after a failed submit re-renders the page */
    select.addEventListener('change', paint);
    paint();

    return function destroy() {
      document.removeEventListener('mousedown', onDocDown);
      revoke();
    };
  }

  var teardown = [];

  function start(scope) {
    if (!scope || !scope.querySelectorAll) { return; }
    Array.prototype.forEach.call(scope.querySelectorAll('.riivah-lp-contact'), function (root) {
      var off = init(root);
      if (off) { teardown.push(off); }
    });
  }

  start(document);

  document.addEventListener('shopify:section:load', function (event) { start(event.target); });
  document.addEventListener('shopify:section:unload', function () {
    teardown.forEach(function (off) { off(); });
    teardown = [];
  });
})();

/* CART DRAWER.
   The theme shipped a cart PAGE and no drawer at all. This opens the panel
   added in riivah-lp.css, posts every mutation through the Cart AJAX API, and
   lets the Section Rendering API re-render the drawer and the header rather
   than hand-patching the DOM - the markup is Liquid (money filters, image
   srcsets, the empty/filled footer swap), so re-rendering it server-side is
   the only way to avoid maintaining a second renderer in JS.

   The drawer is a real modal, like the menu overlay: focus moves in on open,
   is trapped while open, and returns on close. Unlike the menu, its content
   CHANGES while it is open, which is why it also needs a live region and
   focus restoration across the re-render. */
(function () {
  var OUT = 280;     /* must match the closing keyframe duration in the CSS */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]),' +
                  ' select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var SECTIONS = 'riivah-cart-drawer';

  var root = null;
  var closer = null;
  var status = null;
  var opener = null;   /* what had focus before we opened */
  var open = false;
  var closing = 0;
  var busy = false;

  function fire(name) {
    var ev;
    try { ev = new CustomEvent(name, { bubbles: true }); }
    catch (e) { ev = document.createEvent('CustomEvent'); ev.initCustomEvent(name, true, false, {}); }
    return ev;
  }

  function siblings() {
    /* everything the drawer is NOT, so it can be made inert while open */
    var out = [];
    var kids = document.body.children;
    var i;
    for (i = 0; i < kids.length; i++) {
      if (kids[i] !== root && !kids[i].contains(root)) { out.push(kids[i]); }
    }
    return out;
  }

  function background(hide) {
    var list = siblings();
    var i;
    for (i = 0; i < list.length; i++) {
      if (hide) {
        list[i].setAttribute('aria-hidden', 'true');
        if ('inert' in list[i]) { list[i].inert = true; }
      } else {
        list[i].removeAttribute('aria-hidden');
        if ('inert' in list[i]) { list[i].inert = false; }
      }
    }
  }

  function items() {
    if (!root) { return []; }
    var all = root.querySelectorAll(FOCUSABLE);
    var out = [];
    var i;
    for (i = 0; i < all.length; i++) {
      /* skip anything the current breakpoint has hidden */
      if (all[i].offsetWidth || all[i].offsetHeight || all[i].getClientRects().length) { out.push(all[i]); }
    }
    return out;
  }

  function trap(event) {
    if (!open || event.key !== 'Tab') { return; }
    var list = items();
    if (!list.length) { return; }
    var first = list[0];
    var last = list[list.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function say(text) { if (status) { status.textContent = text; } }

  function setOpen(next) {
    if (!root || next === open) { return; }
    open = next;

    if (open) {
      opener = document.activeElement;
      /* one modal at a time: the menu and the drawer both lock body scroll,
         and closing one would unlock it while the other is still up */
      document.dispatchEvent(fire('riivah:cart-open'));
    }

    /* the panel has to stay laid out while it slides away, so closing swaps
       .is-open for .is-closing and drops that one beat later */
    if (closing) { window.clearTimeout(closing); closing = 0; }
    root.classList.remove('is-closing');
    if (!open) {
      root.classList.add('is-closing');
      closing = window.setTimeout(function () {
        closing = 0;
        if (root) { root.classList.remove('is-closing'); }
      }, OUT);
    }

    root.classList.toggle('is-open', open);
    document.body.classList.toggle('riivah-lp-cart-open', open);
    background(open);

    if (open) {
      if (closer) {
        closer.focus();
      } else {
        var list = items();
        if (list.length) { list[0].focus(); }
      }
    } else if (opener && opener.focus) {
      opener.focus();
      opener = null;
    }
  }

  /* ---- focus across the re-render ----
     applySections() replaces innerHTML, which silently drops focus to <body>.
     Record a stable descriptor first and restore it after; if the row is gone
     (the quantity hit 0) land somewhere sane rather than nowhere. */
  function token() {
    var el = document.activeElement;
    if (!el || el === document.body || !root || !root.contains(el)) { return null; }
    return { key: el.getAttribute('data-key'), role: el.getAttribute('data-role') };
  }

  function restore(tk) {
    if (!tk || !root) { return; }
    if (tk.key && tk.role) {
      var el = root.querySelector('[data-key="' + tk.key + '"][data-role="' + tk.role + '"]');
      if (el) { el.focus(); return; }
    }
    var next = root.querySelector('[data-role="qty-inc"]') || closer;
    if (next) { next.focus(); }
  }

  /* ---- Section Rendering ----
     Swap the INNER html so the wrapper node, and therefore the drawer's open
     state and its running animation, survive. */
  /* Lift one row's price and the cart total out of the freshly rendered markup
     and write them into the live DOM, leaving every other node - and the row's
     animation state - untouched. */
  function patch(key, data) {
    if (!root || !data || !data.sections) { return; }
    var html = data.sections['riivah-cart-drawer'];
    if (!html) { return applySections(data); }

    var box = document.createElement('div');
    box.innerHTML = html;

    var freshRow = box.querySelector('.riivah-lp-cart-item[data-key="' + key + '"]');
    var liveRow = root.querySelector('.riivah-lp-cart-item[data-key="' + key + '"]');
    if (!freshRow || !liveRow) { return applySections(data); }

    var freshPrice = freshRow.querySelector('.riivah-lp-cart-item-price');
    var livePrice = liveRow.querySelector('.riivah-lp-cart-item-price');
    if (freshPrice && livePrice) {
      livePrice.textContent = freshPrice.textContent;
      livePrice.classList.remove('is-settling');
    }

    var freshTotal = box.querySelector('.riivah-lp-cart-total-value');
    var liveTotal = root.querySelector('.riivah-lp-cart-total-value');
    if (freshTotal && liveTotal) {
      liveTotal.textContent = freshTotal.textContent;
      liveTotal.classList.remove('is-settling');
    }

    /* trust the server's own quantity over our optimistic one */
    var freshQty = freshRow.querySelector('.riivah-lp-cart-qty-value');
    var liveQty = liveRow.querySelector('.riivah-lp-cart-qty-value');
    if (freshQty && liveQty) { liveQty.textContent = freshQty.textContent; }
  }

  /* Take the row out for good and refresh the figures around it, without
     rebuilding the list and replaying every remaining row's entrance. */
  function drop(key, data) {
    if (!root) { return; }
    var row = root.querySelector('.riivah-lp-cart-item[data-key="' + key + '"]');
    if (row && row.parentNode) { row.parentNode.removeChild(row); }

    if (!data || !data.sections) { return; }
    var html = data.sections['riivah-cart-drawer'];
    if (!html) { return; }

    var box = document.createElement('div');
    box.innerHTML = html;

    var freshTotal = box.querySelector('.riivah-lp-cart-total-value');
    var liveTotal = root.querySelector('.riivah-lp-cart-total-value');
    if (freshTotal && liveTotal) {
      liveTotal.textContent = freshTotal.textContent;
      liveTotal.classList.remove('is-settling');
    }

    /* The carousels are filtered server-side against what is in the cart, so a
       removed product belongs back among the recommendations. Swap each one
       from the fresh markup - they sit outside the item list, so this does not
       disturb the remaining rows. */
    recs(box);
  }

  /* replace the recommendation carousels from freshly rendered markup */
  function recs(box) {
    if (!root || !box) { return; }
    var fresh = box.querySelectorAll('.riivah-lp-cart-recs');
    var live = root.querySelectorAll('.riivah-lp-cart-recs');
    if (!fresh.length || fresh.length !== live.length) {
      /* the number of carousels changed - the empty state adds the samples one -
         so the body's shape is different and a targeted swap cannot express it */
      var liveBody = root.querySelector('.riivah-lp-cart-body');
      var freshBody = box.querySelector('.riivah-lp-cart-body');
      if (liveBody && freshBody) { liveBody.innerHTML = freshBody.innerHTML; }
      carousels();
      return;
    }
    Array.prototype.forEach.call(live, function (el, i) {
      el.innerHTML = fresh[i].innerHTML;
    });
    carousels();
  }

  function applySections(data) {
    if (!data || !data.sections) { return; }
    var tk = token();
    Object.keys(data.sections).forEach(function (id) {
      var live = document.getElementById('shopify-section-' + id);
      if (!live) { return; }
      var box = document.createElement('div');
      box.innerHTML = data.sections[id];
      var fresh = box.querySelector('#shopify-section-' + id);
      var markup = fresh ? fresh.innerHTML : box.innerHTML;

      /* The drawer's own section is a special case: replacing the whole thing
         would swap out the element carrying .is-open, so an add or a remove
         would tear the panel down and slide it back in - or just close it.
         Swap only the CONTENTS that changed and leave the root, its class and
         its running animation alone. */
      var liveRoot = live.querySelector('#riivah-cart-drawer');
      var freshRoot = box.querySelector('#riivah-cart-drawer');
      if (liveRoot && freshRoot) {
        var liveBody = liveRoot.querySelector('.riivah-lp-cart-body');
        var freshBody = freshRoot.querySelector('.riivah-lp-cart-body');
        var liveFoot = liveRoot.querySelector('.riivah-lp-cart-foot');
        var freshFoot = freshRoot.querySelector('.riivah-lp-cart-foot');
        var liveCount = liveRoot.querySelector('.riivah-lp-cart-count');
        var freshCount = freshRoot.querySelector('.riivah-lp-cart-count');
        if (liveBody && freshBody) {
          liveBody.innerHTML = freshBody.innerHTML;
          stagger(liveBody);
        }
        if (liveFoot && freshFoot) {
          liveFoot.innerHTML = freshFoot.innerHTML;
          /* the empty and filled footers differ by a class, not just content */
          liveFoot.className = freshFoot.className;
        }
        if (liveCount && freshCount) { liveCount.innerHTML = freshCount.innerHTML; }
        return;
      }

      live.innerHTML = markup;
      /* Section Rendering does NOT fire shopify:section:load - that event is
         theme-editor only - and the header swap replaces the menu overlay's
         DOM node, whose IIFE holds stale references until it re-attaches. */
      live.dispatchEvent(fire('shopify:section:load'));
    });
    resolve();
    background(open);
    restore(tk);
  }

  /* Every request goes through post(), so the progress bar is driven from here
     rather than from each caller. Counted, because an add and a quantity change
     can overlap and the bar must not stop while one of them is still running. */
  var inflight = 0;

  function working(on) {
    inflight += on ? 1 : -1;
    if (inflight < 0) { inflight = 0; }
    if (root) { root.classList.toggle('is-working', inflight > 0); }
  }

  function post(url, body) {
    working(true);
    body.sections = SECTIONS;
    /* NOT window.location.pathname: on the homepage that makes Shopify render
       all thirteen landing-page sections, video and all, just to return the
       drawer - which is where the multi-second waits came from. The drawer's
       markup depends on the cart, not on the page the shopper is standing on. */
    body.sections_url = '/cart';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) { throw data; }
        return data;
      });
    }).then(function (data) {
      working(false);
      return data;
    }, function (err) {
      working(false);
      throw err;
    });
  }

  function count(data) {
    var n = data && typeof data.item_count === 'number' ? data.item_count : null;
    if (n === null) { return ''; }
    return n + (n === 1 ? ' item in cart.' : ' items in cart.');
  }

  /* The header is no longer re-rendered - it exists to show a number, and
     rendering a whole section for that was most of the wait. Write it directly.
     Every cart label on the page is "Cart (n)", so one pass covers the header,
     the menu overlay's two, and the drawer's own. */
  function counts(data) {
    if (!data || typeof data.item_count !== 'number') { return; }
    var labels = document.querySelectorAll(
      '.riivah-lp-header-cart, .riivah-lp-header-menu-cart,' +
      ' .riivah-lp-header-menu-cart-btn, .riivah-lp-cart-count');
    Array.prototype.forEach.call(labels, function (el) {
      var node = lastText(el);
      if (node) { node.nodeValue = node.nodeValue.replace(/\(\s*\d+\s*\)/, '(' + data.item_count + ')'); }
    });
    /* the phone header shows the count as a badge on the icon instead */
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-badge]'), function (el) {
      el.textContent = data.item_count;
      el.hidden = data.item_count === 0;
    });
  }

  /* Read the real cart and paint its count. /cart.js is a plain GET that always
     returns the whole cart, which is what the add endpoint does not. */
  function totals() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        counts(cart);
        return cart && typeof cart.item_count === 'number' ? cart.item_count : null;
      })
      .catch(function () { return null; });
  }

  /* the count lives in a bare text node beside an <img>, so walk to it rather
     than rewriting the element and destroying the icon */
  function lastText(el) {
    var found = null;
    var kids = el.childNodes;
    var i;
    for (i = 0; i < kids.length; i++) {
      if (kids[i].nodeType === 3 && /\(\s*\d+\s*\)/.test(kids[i].nodeValue)) { found = kids[i]; }
    }
    return found;
  }

  function fail(err) {
    say((err && (err.description || err.message)) || 'Something went wrong. Please try again.');
  }

  /* Paint the new quantity straight away and let the server catch up. A stepper
     that waits for a round trip feels broken however fast the round trip is, and
     the arithmetic here is trivial - so do it locally, send the request, and
     reconcile with whatever the server says when it answers.
     Rapid clicks coalesce: each one repaints immediately and reschedules the
     request, so holding + fires one call with the final number rather than one
     call per press. */
  var pending = {};
  /* the quantity the shopper has actually landed on, per row. A response that
     answers an earlier number is stale by the time it arrives and must not be
     painted, or the price walks up through 4, 5, 6 on its way to 7. */
  var wanted = {};

  function optimistic(key, qty) {
    if (!root) { return; }
    var row = root.querySelector('.riivah-lp-cart-item[data-key="' + key + '"]');
    if (!row) { return; }

    if (qty === 0) {
      row.hidden = true;
      return;
    }

    var value = row.querySelector('.riivah-lp-cart-qty-value');
    if (value) { value.textContent = qty; }

    /* keep the buttons' own targets in step, or a second click would send a
       quantity computed from the number we have just replaced */
    var dec = row.querySelector('[data-role="qty-dec"]');
    var inc = row.querySelector('[data-role="qty-inc"]');
    if (dec) { dec.setAttribute('data-qty', qty - 1); }
    if (inc) { inc.setAttribute('data-qty', qty + 1); }

    /* the line price and the total are the server's to compute - mark them as
       settling rather than showing a number we would have to guess */
    var price = row.querySelector('.riivah-lp-cart-item-price');
    var total = root.querySelector('.riivah-lp-cart-total-value');
    if (price) { price.classList.add('is-settling'); }
    if (total) { total.classList.add('is-settling'); }
  }

  function change(key, qty, btn) {
    optimistic(key, qty);
    wanted[key] = qty;

    if (pending[key]) { window.clearTimeout(pending[key]); }
    pending[key] = window.setTimeout(function () {
      delete pending[key];
      send(key, qty, btn);
    }, 220);
  }

  function send(key, qty, btn) {
    /* the shopper moved on while this was queued - skip it entirely */
    if (wanted[key] !== undefined && wanted[key] !== qty) { return; }

    if (busy) {
      /* something else is mid-flight; try again once it lands */
      pending[key] = window.setTimeout(function () {
        delete pending[key];
        send(key, qty, btn);
      }, 120);
      return;
    }
    busy = true;
    post('/cart/change.js', { id: key, quantity: qty })
      .then(function (data) {
        /* and the shopper may have moved on while it was IN FLIGHT. The cart is
           correct either way - a later request is already on its way - but
           painting this answer would show a number they have passed. */
        if (wanted[key] !== undefined && wanted[key] !== qty) { return; }
        /* this answer is the current one, so the row has caught up. Clear the
           filter HERE, not in the finally: if a stale response is skipped above,
           the finally would leave wanted[key] set and the row's next action
           would be discarded as stale too. */
        delete wanted[key];
        /* A quantity change touches one row's price and the total - nothing
           else. Re-rendering the whole body for that replays the row entrance
           animation and reads as the cart reloading, so patch the figures in
           place instead. Only a removal changes the shape of the list enough
           to need the server's markup. */
        if (qty === 0) {
          /* an emptied cart swaps the whole drawer - empty message, different
             footer - but removing one line out of several is just a row going */
          if (data && data.item_count === 0) {
            applySections(data);
          } else {
            drop(key, data);
          }
        } else {
          patch(key, data);
        }
        counts(data);
        say((qty === 0 ? 'Item removed. ' : 'Quantity updated. ') + count(data));
      })
      .catch(function (err) {
        /* the optimistic paint was a guess and it was wrong - put the real cart
           back rather than leaving the shopper looking at a number we invented */
        fail(err);
        delete wanted[key];
        refresh();
      })
      .then(function () { busy = false; });
  }

  /* pull the authoritative cart and re-render from it */
  function refresh() {
    return post('/cart/update.js', {})
      .then(function (data) { applySections(data); counts(data); })
      .catch(function () {});
  }

  function add(id, qty, btn) {
    if (busy) { return; }
    busy = true;
    var label = btn && btn.querySelector('.riivah-lp-cart-rec-add-label');
    var was = label && label.textContent;
    if (btn) {
      btn.disabled = true;
      btn.classList.add('is-adding');
      if (label) { label.textContent = 'Adding to cart...'; }
    }
    post('/cart/add.js', { items: [{ id: id, quantity: qty || 1 }] })
      .then(function (data) {
        applySections(data);
        setOpen(true);   /* an add from the page opens the drawer - that is the point of it */
        /* /cart/add.js answers with the LINE IT ADDED, not the cart, so it has
           no item_count and the header would stay on its old number. Ask the
           cart itself for the total. */
        return totals().then(function (n) {
          say('Added to cart. ' + (n === null ? '' : n + (n === 1 ? ' item in cart.' : ' items in cart.')));
        });
      })
      .catch(fail)
      .then(function () {
        busy = false;
        /* Restore the button whatever happened. Only the recommendation cards
           are replaced by the re-render; the homepage product buttons are not,
           so leaving them disabled on SUCCESS stranded them for good. */
        if (btn && btn.isConnected !== false) {
          btn.disabled = false;
          btn.classList.remove('is-adding');
          if (label && was) { label.textContent = was; }
        }
      });
  }

  /* ---- delegated handlers: they survive every re-render without re-binding ---- */
  function onClick(event) {
    var t = event.target;
    if (!t || !t.closest) { return; }

    if (t.closest('[data-cart-open]')) { event.preventDefault(); setOpen(true); return; }

    var close_el = t.closest('[data-cart-close]');
    if (close_el && root && root.contains(close_el)) { event.preventDefault(); setOpen(false); return; }

    var btn = t.closest('[data-role]');
    if (!btn || !root || !root.contains(btn)) { return; }
    var role = btn.getAttribute('data-role');
    if (role === 'add') {
      event.preventDefault();
      add(btn.getAttribute('data-id'), 1, btn);
    } else if (role === 'qty-dec' || role === 'qty-inc' || role === 'remove') {
      event.preventDefault();
      change(btn.getAttribute('data-key'), parseInt(btn.getAttribute('data-qty'), 10), btn);
    }
  }

  /* the two homepage product sections are {% form 'product' %} tags that post
     to /cart/add and redirect to /cart. Intercepting keeps the drawer in play
     while leaving the real form as the no-JS path. */
  function onSubmit(event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains('riivah-lp-product-buy')) { return; }
    var id = form.querySelector('input[name="id"]');
    if (!id) { return; }            /* never strand the customer: let it post for real */
    event.preventDefault();
    /* the full-size and sample buttons carry different classes, so ask for the
       submit control itself rather than naming one of them */
    add(id.value, 1, form.querySelector('button[type="submit"]'));
  }

  function onKey(event) {
    if (event.key === 'Escape') { setOpen(false); }
    trap(event);
  }

  function resolve() {
    root = document.getElementById('riivah-cart-drawer');
    closer = root ? root.querySelector('.riivah-lp-cart-close') : null;
    status = root ? root.querySelector('.riivah-lp-cart-status') : null;
    carousels();
  }

  /* Number the rows so the CSS can cascade their entrance, and re-arm the
     animation on each re-render - a class that is already present would not
     replay it, so it comes off and goes back on across a reflow. */
  function stagger(body) {
    var list = body.querySelector('.riivah-lp-cart-items');
    if (!list) { return; }
    var rows = list.querySelectorAll('.riivah-lp-cart-item');
    Array.prototype.forEach.call(rows, function (row, i) {
      row.style.setProperty('--riivah-cart-row', i);
    });
    list.classList.remove('is-fresh');
    void list.offsetWidth;
    list.classList.add('is-fresh');
  }

  /* The recommendation tracks scroll natively, but their scrollbar is hidden, so
     on a mouse there is nothing to grab. Give each one a pair of arrows, and
     hide them entirely when the cards already fit. */
  function carousels() {
    if (!root) { return; }
    var lists = root.querySelectorAll('[data-recs]');
    Array.prototype.forEach.call(lists, function (recs) {
      var track = recs.querySelector('[data-recs-track]');
      var nav = recs.querySelector('[data-recs-nav]');
      var prev = recs.querySelector('[data-recs-prev]');
      var next = recs.querySelector('[data-recs-next]');
      if (!track || !nav || !prev || !next) { return; }

      function step() {
        var card = track.querySelector('.riivah-lp-cart-rec');
        if (!card) { return track.clientWidth; }
        var styles = window.getComputedStyle(track);
        return card.offsetWidth + (parseFloat(styles.columnGap || styles.gap) || 0);
      }

      function sync() {
        var slack = track.scrollWidth - track.clientWidth;
        /* 2px of slack is rounding, not a second page */
        nav.hidden = slack <= 2;
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= slack - 1;
      }

      prev.addEventListener('click', function () { track.scrollLeft -= step(); });
      next.addEventListener('click', function () { track.scrollLeft += step(); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync, { passive: true });
      sync();
    });
  }

  /* The server-rendered count goes stale when the page is not re-rendered: the
     Back button restores it from the back/forward cache (e.g. returning from
     checkout or /cart), and another tab can change the cart. Re-read it then. */
  window.addEventListener('pageshow', function (event) { if (event.persisted) { totals(); } });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') { totals(); }
  });

  resolve();
  if (!root) { return; }

  document.addEventListener('click', onClick);
  document.addEventListener('submit', onSubmit);
  document.addEventListener('keydown', onKey);
  /* one modal at a time */
  document.addEventListener('riivah:menu-open', function () { if (open) { setOpen(false); } });

  /* the theme editor swaps the section out; re-resolve and re-sync to our state */
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector) { return; }
    if (!event.target.querySelector('.riivah-lp-cart')) { return; }
    resolve();
    open = false;
    if (closing) { window.clearTimeout(closing); closing = 0; }
    if (root) { root.classList.remove('is-open'); root.classList.remove('is-closing'); }
    document.body.classList.remove('riivah-lp-cart-open');
    background(false);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target || !event.target.querySelector) { return; }
    if (!event.target.querySelector('.riivah-lp-cart')) { return; }
    setOpen(false);
    root = null; closer = null; status = null;
  });
})();
